module.exports = __webpack_public_path__ + "img/1694659074749-16946590451073710257535275574946.jpg.c8601171.webp";